import React, { useCallback, useEffect } from 'react'
import {
    Button,
    // NavigationLinkButton 
} from '../../../components/RegularComponents'
import '../BLTHome/BLTHome.styles.scss'
import ApplicationStatusComponent from '../BLTCommon/ApplicationStatus'
import { 
    APPLICATION_STATUS_APPROVED_ISSUED,
    APPLICATION_STATUS_PENDING_AGENCY, 
    APPLICATION_STATUS_WITHDRAWN_BY_CLIENT,
    LICENCE_STATUS_ACTIVE,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION, 
} from '../../../app/constants'
import { useDispatch } from 'react-redux'
import { fetchQueue, setSortingParameters } from '../../../redux/slice/bltHomeSlice'
import { Pagination } from '../../../components/Pagination/Pagination'
import { 
    applicationTypeFromLicenceSubType, 
    isMortgageTypeApplication, 
    isRenewalTypeLicencingSubType 
} from '../../../redux/slice/applicationsUtils'

// import { 
//     LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION, 
//     LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION 
// } from '../../../app/constants'

export default function BLTHomeQueue(props) {

    const MAX_NUMBER_OF_RECORDS_PER_PAGE = 20
    const { headers, queueItems, onReviewButtonClick, onConfirmWithdrawnByClient, paginationData, bltHome, page, setPage } = props
    const { sortingParameters } = bltHome

    const dispatch = useDispatch();

    const getSortIcon = (header) => {
        if(!header.sortBy) {
            return null;
        }

        if(header.key !== sortingParameters?.key) {
            return <i style={{color: "lightgray"}} className={`fa fa-2x fa-sort`}/>
        }
        const activeClass = header.key === sortingParameters?.key ? "active": ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4": "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{color: activeStyle}} className={`fa fa-2x ${activeClass} ${iconStr}`}/>
    }

    const sendQueueRequestCB = useCallback(() => {
        const sortByType = sortingParameters.sortBy + (!sortingParameters?.isAscending  ? "_DESC" : "_ASC")
        dispatch(fetchQueue({page, numberOfRecords: MAX_NUMBER_OF_RECORDS_PER_PAGE, sortType: sortByType}))
    }, [page, dispatch, sortingParameters])

    if(!bltHome.queue) {
        sendQueueRequestCB()
    }
    
    const headerClicked = (header) => () => {
        
        if(!header.sortBy)
            return

        let modifiedSortingParams = {...sortingParameters}

        if(header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else { 
            modifiedSortingParams = {key: header.key, isAscending: false, sortBy: header.sortBy}
        }
        
        dispatch(setSortingParameters(modifiedSortingParams))
    }

    useEffect(() => {
        sendQueueRequestCB()
    }, [sendQueueRequestCB])

    return (
        <>
            <div className="col-lg-12">
                <h2>Queue</h2>
            </div>
            <div className="col-lg-12">
                <table className="table bltQueueTable">
                    <thead>
                        <tr>
                            {headers.map((h) => (
                                <th key={h.key} style={{fontSize: "1rem"}} onClick={headerClicked(h)}>
                                    <div style={{
                                        display: "inline-flex", 
                                        gap: "0.5rem", 
                                        alignItems: "center",
                                        cursor : h.sortBy ? "pointer" : "arrow",
                                        paddingRight:"20px"
                                    }}>{h.title} {getSortIcon(h)}</div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {queueItems.length ?
                        (<tbody>
                            {queueItems.map((row, rowIndex) => {
                                const rowElement = []

                                headers.forEach((h) => {
                                    if (Object.hasOwnProperty.call(row, h.key)) {
                                        const element = row[h.key] ? row[h.key] : null;
                                        if (h.key === "contactNameAndAgency") {
                                            const { contactName, businessName } = row

                                            rowElement.push(
                                                <td key={h.key + "-" + rowIndex}>
                                                    {contactName ? <span>{contactName}</span> : <span>Unknown</span>}
                                                    <br />
                                                    {businessName ? <span style={{ fontWeight: "bold" }}>{businessName}</span> : <span style={{ fontWeight: "bold" }}>Unknown</span>}
                                                </td>
                                            )

                                            // if(contactName && businessName) {
                                            //     if(row.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
                                            //         || (row.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION)) {
                                            //             rowElement.push(
                                            //                 <td key={h.key + "-" + rowIndex}>
                                            //                     <NavigationLinkButton 
                                            //                         style={{textAlign: "left"}}
                                            //                         text = {<strong>{contactName}</strong>} 
                                            //                         onClick={() => {
                                            //                             // push to details view
                                            //                         }}/>
                                            //                     <br />
                                            //                     <NavigationLinkButton 
                                            //                         style={{textAlign: "left"}}
                                            //                         text = {<strong>{businessName}</strong>} 
                                            //                         onClick={() => {
                                            //                             // push to details view
                                            //                         }}/>
                                            //                 </td>
                                            //             )
                                            //     } else { 
                                            //         rowElement.push(
                                            //             <td key={h.key + "-" + rowIndex}>
                                            //                 <span style={{marginLeft : "5px"}}>{contactName}</span>
                                            //                 <br />
                                            //                 <NavigationLinkButton 
                                            //                     style={{textAlign: "left"}}
                                            //                     text = {<strong>{businessName}</strong>} 
                                            //                     onClick={() => {
                                            //                         // push to details view
                                            //                     }}/>
                                            //             </td>
                                            //         )
                                            //     }
                                            // }
                                        } else if (h.key === "applicationStatus") {
                                            rowElement.push(
                                                <td key={h.key + "-" + rowIndex}>
                                                    {<ApplicationStatusComponent
                                                        applicationStatus={element} 
                                                        licencingSubType={row["licencingSubType"]}
                                                        licenceStatus={row["licenceStatus"]}
                                                    />}
                                                </td>
                                            )
                                        }
                                        else {
                                            rowElement.push(
                                                <td key={h.key + "-" + rowIndex}>{element}</td>
                                            )
                                        }
                                    } else if (h.key === "review_button") {
                                        rowElement.push(
                                          <td key={h.key + "-" + rowIndex}>
                                            {row.readOnly ? (
                                              <>
                                                <Button
                                                  id="licence-queue-review-readonly-button"
                                                  className={"licence-queue-review-readonly-button"}
                                                  buttonType="regular_primary"
                                                  text="Read only"
                                                  onClick={() => {
                                                    // change to the details screens
                                                    onReviewButtonClick(row.id);
                                                  }}
                                                />
                                                {row.locked && (
                                                  <div className="lockedByText">
                                                    <strong>Locked by</strong>
                                                    <br />
                                                    <span>{row.locked}</span>
                                                  </div>
                                                )}
                                              </>
                                            ) :0 && row.applicationStatus ===
                                              APPLICATION_STATUS_WITHDRAWN_BY_CLIENT ? ( //Not needed, replaced with Cancel adjudication
                                              <Button
                                                id="licence-queue-confirm-button"
                                                className={"licence-queue-confirm-button"}
                                                buttonType="regular_success"
                                                text="Confirm"
                                                onClick={() => {
                                                  onConfirmWithdrawnByClient(
                                                    row.id,
                                                    sendQueueRequestCB
                                                  );
                                                }}
                                              />
                                            ) : (
                                              ((isMortgageTypeApplication(
                                                applicationTypeFromLicenceSubType(
                                                  row.licencingSubType
                                                )
                                              ) &&
                                                !isRenewalTypeLicencingSubType(
                                                  row.licencingSubType
                                                )) ||
                                                row.applicationStatus !==
                                                  APPLICATION_STATUS_PENDING_AGENCY) && (
                                                <Button
                                                    id="licence-queue-review-button"
                                                    className={"licence-queue-review-button"}
                                                    buttonType="regular_primary"
                                                    text={
                                                        (row.licenceStatus === LICENCE_STATUS_ACTIVE &&
                                                        !(row.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED || row.applicationStatus === APPLICATION_STATUS_WITHDRAWN_BY_CLIENT)
                                                         && row.licencingSubType !== LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION) 
                                                        ? "Review document" //For document uploaded separately
                                                        : "Review"
                                                    }
                                                    onClick={() => {
                                                        // change to the details screens
                                                        onReviewButtonClick(row.id);
                                                    }}
                                                />
                                              )
                                            )}
                                          </td>
                                        );
                                    }
                                })

                                return (<tr key={"row-" + rowIndex}>{rowElement}</tr>)
                            })}
                        </tbody>) :
                        (<tbody>
                            <tr>
                                <td colSpan="6">
                                    <div className="statusText centered">(no items)</div>
                                </td>
                            </tr>
                        </tbody>)}
                </table>
                <div className="row paginationWrapper">
                    <div className="col-12">
                        <Pagination 
                            totalPages={paginationData?.totalRecords ? Math.ceil(paginationData?.totalRecords / MAX_NUMBER_OF_RECORDS_PER_PAGE): 0}
                            currentPage={page ?? 0}
                            onPageChange={(pageNum) => {
                                setPage(pageNum)
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
